// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f756e35b","239":"d2115fe5","455":"f425c0cf"}[chunkId] + ".chunk.js";
};